<!--
 * @Author: your name
 * @Date: 2021-02-22 19:10:27
 * @LastEditTime: 2021-10-26 11:07:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lwdgis-ui-master\src\MyAccountV2.vue
-->

<template>
    <el-card style="
            width: 100%;
            margin-top: 0px;
            padding-top: 0px;
            background: url(/static/img/地理调查表背景.png);
        ">
        <!-- <el-card style="height: 1372px;width:1680px;margin-left:120px;margin-top:30px"> -->
        <el-card style="
                height: 225px;
                width: 1680px;
                margin-left: 120px;
                margin-top: 30px;
            ">
            <el-row>
                <el-col :span="1" style="margin-top: 20px; margin-left: 30px">
                    <div style="width: 6px; height: 24px; background: #12c287"></div>
                </el-col>
                <el-col :span="2" style="margin-top: 14px; margin-left: -70px">
                    <span style="
                            font-size: 24px;
                            color: #000000;
                            font-weight: 500;
                        ">
                        个人信息
                    </span>
                </el-col>
                <el-col :span="1" :offset="19" style="margin-top: 18px; cursor: pointer">
                    <div @click="goto_change_password">
                        <el-button icon="el-icon-edit" circle style="text-align: right; color: #12c287"
                            size="mini"></el-button>
                    </div>
                </el-col>
                <el-col :span="1" style="
                        margin-top: 20px;
                        margin-left: -23px;
                        cursor: pointer;
                    ">
                    <div @click="goto_change_password">
                        <span style="
                                color: #12c287;
                                font-weight: 400;
                                font-size: 16px;
                            ">
                            修改密码
                        </span>
                    </div>
                </el-col>
            </el-row>
            <div style="
                    width: 100%;
                    height: 1px;
                    background: #e8e8e8;
                    margin-top: 14px;
                "></div>
            <el-row>
                <el-col :offset="1" :span="11">
                    <div class="account-info-title" style="
                            font-size: 20px;
                            line-height: 22px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 0.85);
                        ">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;姓名：{{
                            accountInfo.tName
                        }}
                    </div>
                    <div class="account-info-title" style="
                            font-size: 20px;
                            line-height: 22px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 0.85);
                            margin-top: 20px;
                        ">
                        工作单位：{{ accountInfo.work }}
                    </div>
                    <div class="account-info-title" style="
                            font-size: 20px;
                            line-height: 22px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 0.85);
                            margin-top: 20px;
                        ">
                        <el-row>
                            <el-col :span="2" :offset="1"> 等级： </el-col>
                            <el-col :span="10" style="margin-top: 10px">
                                <el-progress :stroke-width="16" :show-text="false"
                                    :percentage="(100 * percentages) / Lv_pt"></el-progress>
                            </el-col>
                            <el-col :offset="1" :span="4">
                                <el-tag>{{ $store.state.userLv }}</el-tag>

                                <span style="line-height: 30px">{{ percentages }}/{{ Lv_pt }}</span>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
                <el-col :span="6" :offset="2">
                    <el-row>
                        <div class="account-info-title" style="
                                font-size: 20px;
                                line-height: 22px;
                                font-weight: 400;
                                color: rgba(0, 0, 0, 0.85);
                            ">
                            邮箱：{{ accountInfo.mail }}
                        </div>
                        <div class="account-info-title" style="
                                font-size: 20px;
                                line-height: 22px;
                                font-weight: 400;
                                color: rgba(0, 0, 0, 0.85);
                                margin-top: 20px;
                            ">
                            职位：{{ accountInfo.job }}
                        </div>
                    </el-row>
                </el-col>

            </el-row>
        </el-card>

        <el-card style="
                width: 1680px;
                height: 520px;

                margin-top: 10px;
                margin-bottom: 10px;
                margin-left: 120px;
            ">
            <el-row>
                <el-col :span="1" style="margin-top: 20px; margin-left: 30px">
                    <div style="width: 6px; height: 24px; background: #12c287"></div>
                </el-col>
                <el-col :span="2" style="margin-top: 14px; margin-left: -70px">

                    <span style="
                            font-size: 24px;
                            color: #000000;
                            font-weight: 500;
                        ">
                        我的数据
                    </span>
                </el-col>
            </el-row>
            <div style="
                    width: 100%;
                    height: 1px;
                    background: #e8e8e8;
                    margin-top: 14px;
                "></div>
            <el-row style="margin-top: 30px; margin-left: 20px">
                <el-col :offset="1" :span="23">
                    <el-table :header-cell-style="{
                        background: '#eef1f6',
                        color: '#606266',
                    }" :data="myData.slice(
    (myDataCurrentPage - 1) * myDataPagesize,
    myDataCurrentPage * myDataPagesize
)
    " style="width: 100%; font-size: 18px">
                        <el-table-column label="定位聚落" width="270">
                            <template slot-scope="scope">
                                {{
                                    scope.row.juluo +
                                    '（' +
                                    scope.row.country +
                                    '）'
                                }}
                            </template>
                        </el-table-column>

                        <el-table-column property="nPosition" label="今地名" :show-overflow-tooltip="true" width="380">
                        </el-table-column>
                        <el-table-column property="date" label="定位日期" width="260">
                        </el-table-column>
                        <el-table-column label="审核日期" width="260">
                            <template slot-scope="scope">
                                <span :style="{
                                    color:
                                        scope.row.checkDate == '尚未审核'
                                            ? 'gray'
                                            : '#606266',
                                }">
                                    {{ scope.row.checkDate }}
                                </span>
                            </template>
                        </el-table-column>

                        <el-table-column label="操作" width="260">
                            <template slot-scope="scope">
                                <el-button type="primary" @click="jumpViewJuLuo(scope.row)"
                                    icon="el-icon-s-promotion">查看地图</el-button>
                                <el-button type="danger" icon="el-icon-delete" v-if="scope.row.checkDate == '尚未审核'"
                                    @click="deletechecking(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination style="margin-top: 15px" align="center" @current-change="myDataHandleCurrentChange"
                        :current-page="myDataCurrentPage" :page-size="myDataPagesize" layout="prev, pager, next "
                        :total="myData.length">
                    </el-pagination>
                </el-col>
            </el-row>
        </el-card>
        <el-card v-if="adminAccountFlag" style="
                width: 1680px;
                height: 460px;

                margin-top: 10px;
                margin-bottom: 10px;
                margin-left: 120px;
            ">
            <el-row>
                <el-col :span="1" style="margin-top: 20px; margin-left: 30px">
                    <div style="width: 6px; height: 24px; background: #12c287"></div>
                </el-col>
                <el-col :span="2" style="margin-top: 14px; margin-left: -70px">
                    <span style="
                            font-size: 24px;
                            color: #000000;
                            font-weight: 500;
                        ">
                        注册用户
                    </span>
                </el-col>
            </el-row>
            <div style="
                    width: 100%;
                    height: 1px;
                    background: #e8e8e8;
                    margin-top: 14px;
                "></div>
            <el-row style="margin-top: 30px; margin-left: 20px">
                <el-col :offset="1" :span="23">
                    <el-table :header-cell-style="{
                        background: '#eef1f6',
                        color: '#606266',
                    }" :data="adminMyData.slice(
    (adminMyDataCurrentPage - 1) * adminMyDataPagesize,
    adminMyDataCurrentPage * adminMyDataPagesize
)
    " style="width: 100%; font-size: 18px">
                        <el-table-column label="用户姓名" width="150">
                            <template slot-scope="scope">
                                {{
                                    scope.row.tName
                                }}
                            </template>
                        </el-table-column>

                        <el-table-column label="用户邮箱" width="250">
                            <template slot-scope="scope">
                                {{
                                    scope.row.mail
                                }}
                            </template>
                        </el-table-column>

                        <el-table-column label="工作单位" width="250">
                            <template slot-scope="scope">
                                {{
                                    scope.row.work
                                }}
                            </template>
                        </el-table-column>

                        <el-table-column label="职位" width="150">
                            <template slot-scope="scope">
                                {{
                                    scope.row.job
                                }}
                            </template>
                        </el-table-column>

                        <el-table-column label="权限" width="150">
                            <template slot-scope="scope">
                                {{
                                    scope.row.role
                                }}
                            </template>
                        </el-table-column>

                        <el-table-column label="已审核聚落个数" width="150" :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                {{
                                    formatchecked(scope.row.checked)
                                }}
                            </template>
                        </el-table-column>
                        <el-table-column label="在审核聚落个数" width="150" :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                {{
                                    formatchecked1(scope.row.checking)
                                }}
                            </template>
                        </el-table-column>

                        <el-table-column label="操作" width="180">
                            <template slot-scope="scope">
                                <el-button type="primary" icon="el-icon-notebook-2"
                                    @click="adminDataViewDetil(scope.row)">查看详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination style="margin-top: 15px" align="center" @current-change="adminMyDataHandleCurrentChange"
                        :current-page="adminMyDataCurrentPage" :page-size="adminMyDataPagesize" layout="prev, pager, next "
                        :total="adminMyData.length">
                    </el-pagination>
                </el-col>
            </el-row>
        </el-card>

        <el-card style="
                width: 1680px;
                height: 440px;
                margin-top: 10px;
                margin-bottom: 10px;
                margin-left: 120px;
            ">
            <el-row>
                <el-col :span="1" style="margin-top: 20px; margin-left: 30px">
                    <div style="width: 6px; height: 24px; background: #12c287"></div>
                </el-col>
                <el-col :span="2" style="margin-top: 14px; margin-left: -70px">
                    <span style="
                            font-size: 24px;
                            color: #000000;
                            font-weight: 500;
                        ">
                        积分记录
                    </span>
                </el-col>

                <el-col :span="2" :offset="19" style="margin-top: 18px">
                    <el-link style="text-align: right; color: #12c287" size="mini" @click="goto_point_rule">查看积分规则</el-link>
                </el-col>
            </el-row>
            <div style="
                    width: 100%;
                    height: 1px;
                    background: #e8e8e8;
                    margin-top: 14px;
                "></div>
            <el-row style="margin-top: 30px; margin-left: 20px">
                <el-col :offset="1" :span="23">
                    <div>
                        <el-table :header-cell-style="{
                            background: '#eef1f6',
                            color: '#606266',
                        }" style="width: 90%; font-size: 18px" :data="point_table.slice(
    (recordCurrentPage - 1) * recordPagesize,
    recordCurrentPage * recordPagesize
)
    ">
                            <el-table-column prop="content" label="操作内容"></el-table-column>
                            <el-table-column label="操作对象">
                                <template slot-scope="scope">
                                    {{
                                        scope.row.juluo +
                                        '（' +
                                        scope.row.country +
                                        '）'
                                    }}
                                </template></el-table-column>

                            <el-table-column prop="date" label="操作日期"></el-table-column>
                            <el-table-column label="积分变化">{{
                                '+10'
                            }}</el-table-column>
                        </el-table>
                        <el-pagination style="margin-top: 15px" align="center" @size-change="recordHandleSizeChange"
                            @current-change="recordHandleCurrentChange" :current-page="recordCurrentPage"
                            :page-size="recordPagesize" layout="prev, pager, next " :total="point_table.length">
                        </el-pagination>
                    </div>
                </el-col>
            </el-row>
        </el-card>

        <el-dialog title="修改密码" :visible.sync="code_dialogVisible" width="600px" top="260px" :close-on-click-modal="false">

            <div>
                <el-form :class="[
                    msgIsShow
                        ? 'change-code-form-right'
                        : 'change-code-form-center',
                ]" :model="ruleForm2" :rules="rules2" ref="ruleForm2">
                    <el-form-item prop="username">
                        <el-input class="login-input" v-model="username" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item prop="email">
                        <el-input class="login-input" v-model="ruleForm2.email" auto-complete="off"
                            placeholder="请输入邮箱号"></el-input>
                    </el-form-item>
                    <el-form-item prop="smscode" class="code">
                        <el-input class="login-input" style="" auto-complete="off" v-model="ruleForm2.smscode"
                            placeholder="验证码"></el-input>
                        <el-button type="primary" style="
                                margin-left: 20px;
                                width: 140px;
                                text-align: center;
                            " :disabled="isDisabled" @click="sendCode">{{ buttonText }}</el-button>
                    </el-form-item>
                    <el-form-item prop="pass">
                        <el-input type="password" class="login-input" v-model="ruleForm2.pass" auto-complete="off"
                            placeholder="输入密码"></el-input>
                    </el-form-item>
                    <el-form-item prop="checkPass">
                        <el-input type="password" class="login-input" v-model="ruleForm2.checkPass" auto-complete="off"
                            placeholder="确认密码"></el-input>
                    </el-form-item>

                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm('ruleForm2')">确认修改</el-button>
                <el-button @click="code_dialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>

        <el-dialog title="积分规则" :visible.sync="point_dialogVisible" width="30%" top="260px" :close-on-click-modal="false">
            <el-row>
                <el-col :offset="2">
                    <h4 style="float: left">等级规则</h4>
                    <div id="divChart" style="height: 300px; width: 90%"></div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :offset="2" :span="20">
                    <h4 style="float: left">积分规则</h4>

                    <el-table :data="point_rule_table" :header-cell-style="{
                        background: '#eef1f6',
                        color: '#606266',
                    }">
                        <el-table-column prop="type" label="积分类型"></el-table-column>
                        <el-table-column prop="num" label="积分值"></el-table-column>
                    </el-table>
                </el-col>
            </el-row>

            <!-- <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    @click="point_dialogVisible = false"
                    >确 定</el-button
                >
            </span> -->
        </el-dialog>
        <el-dialog title="用户详情" :visible.sync="accountUserDialogFlag" width="30%" top="260px" :close-on-click-modal="false">
            <el-row style="text-align:left;font-size:18px;">
                <p style="line-height:34px">
                    用户姓名：
                    <strong>{{ accountUserDialogObject.tName
                    }}</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    用户邮箱： <strong>{{ accountUserDialogObject.mail }}</strong><br />
                </p>
                <p style="line-height:34px">
                    职位： <strong>{{ accountUserDialogObject.job }}</strong>
                    <span style="float:right;margin-right:180px"> 权限：
                        <strong>{{ accountUserDialogObject.role }}</strong><br /></span>
                </p>
                <p style="line-height:34px">
                    工作单位： <strong>{{ accountUserDialogObject.work }}</strong>
                </p>
                <p style="line-height:34px">
                    已审核聚落： <strong>{{ formatchecked2(accountUserDialogObject.checked) }}</strong>
                </p>
                <p style="line-height:34px">
                    在审核聚落： <strong>{{ formatchecked3(accountUserDialogObject.checking) }}</strong>
                </p>
            </el-row>

        </el-dialog>
    </el-card>
</template>

<script>
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import { transform } from 'ol/proj'
import GeoJSONFormat from 'ol/format/GeoJSON'
import { WFS, GeoJSON } from 'ol/format'
import {
    fullScreenStartLoading,
    fullScreenEndLoading,
} from '@/V3/js/loading.js'
import axios from 'axios'
import comMainInfo from '@/components/Account/comMainInfo.vue'
import comChangePassword from '@/components/Account/comChangePassword.vue'
import comAddLocation from '@/components/Account/comAddLocation.vue'
import comChangeLocation from '@/components/Account/comChangeLocation.vue'
import comPointInfo from '@/components/Account/comPointInfo.vue'
import comPointRule from '@/components/Account/comPointRule.vue'

import eventBus from '@/V3/js/eventBus'

export default {
    data() {
        let checkUsername = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入用户名'))
            } else {
                callback()
            }
        }
        // <!--验证邮箱号是否合法-->
        let checkTel = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入邮箱号'))
            } else if (!this.checkMobile(value)) {
                callback(new Error('邮箱号不合法'))
            } else {
                callback()
            }
        }
        //  <!--验证码是否为空-->
        let checkSmscode = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入验证码'))
            } else {
                callback()
            }
        }
        // <!--验证密码-->
        let validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'))
            } else {
                if (this.ruleForm2.checkPass !== '') {
                    this.$refs.ruleForm2.validateField('checkPass')
                }
                callback()
            }
        }
        // <!--二次验证密码-->
        let validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'))
            } else if (value !== this.ruleForm2.pass) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        }
        return {
            // 修改密码
            ruleForm2: {
                pass: '',
                checkPass: '',
                email: '',
                smscode: '',
            },
            rules2: {
                pass: [{ validator: validatePass, trigger: 'change' }],
                checkPass: [{ validator: validatePass2, trigger: 'change' }],
                email: [{ validator: checkTel, trigger: 'change' }],
                smscode: [{ validator: checkSmscode, trigger: 'change' }],
            },
            buttonText: '发送验证码',
            isDisabled: false, // 是否禁止点击发送验证码按钮
            flag: true,
            // 修改密码
            code_dialogVisible: false,
            // 积分规则
            point_dialogVisible: false,
            //文字是否展示
            msgIsShow: true,
            screenWidth: document.body.clientWidth,
            pageTitle: '历史地名定位系统',

            my_is_show_menu: false,
            point_rule_table: [
                {
                    type: '定位数据',
                    num: '+10',
                },
                {
                    type: '修改数据',
                    num: '+10',
                },
            ],
            // percentage:0,
            point_table: [],
            comVisParam: {},

            // 历史记录分页
            recordCurrentPage: 1, //初始页
            recordPagesize: 5, //    每页的数据

            // 我的数据
            myData: [],
            myDataCurrentPage: 1, //初始页
            myDataPagesize: 5, //    每页的数据

            // V3 版本 用户信息对象
            accountInfo: {
                mail: '',
                tName: '',
                work: '',
                job: '',
                phone: '',
                points: '',
                other: '',
            },
            userLV: 'LV0',
            // 当前页待审核图层
            currentPageCheckLayer: {},
            tName: '',
            adminAccountFlag: undefined,

            // 管理员能看到所有的注册用户
            adminMyData: [],
            adminMyDataCurrentPage: 1, //初始页
            adminMyDataPagesize: 4, //    每页的数据

            // 已审核 用户名-数据字典
            checkedDataDict: {},
            // 正在审核中 用户名-数据字典
            checkingDataDict: {},

            accountUserDialogFlag: false,
            accountUserDialogObject: {}

        }
    },
    components: {
        comMainInfo,
        comChangePassword,
        comAddLocation,
        comChangeLocation,
        comPointInfo,
        comPointRule,
        comChangePassword,
    },
    computed: {

        // 积分状态
        percentages: function () {
            // return parseInt(this.accountInfo.points)
            return this.$store.state.userPt
        },
        // 当前积分与对应的最高积分
        Lv_pt: function () {
            // 等级配置
            // level_name:['LV1','LV2','LV3','LV4','LV5','LV6','LV7'],
            // level_num:[0,60,180,360,600,1800,3200]
            switch (this.$store.state.userLv) {
                case 'LV2':
                    return 60
                case 'LV3':
                    return 180
                case 'LV4':
                    return 360
                case 'LV5':
                    return 600
                case 'LV6':
                    return 1800
                case 'LV7':
                    return 3200
                default:
                    return 0
            }
        },
        // 用户名
        username: function () {
            return this.$store.state.userName
        },

        usermail: function () {
            return this.$store.state.userEmail
        },


    },
    mounted() {
        this.isAdminAccount()
        this.onLoadCheckedDataDict()
        this.onLoadCheckingDataDict()
        // V3 版本获取用户的信息
        this.getAccountInfo()
        // 获取操作记录
        this.getUserOpertions()
        // 获取我的数据
        this.getMyData()
        this.gettName()

    },
    methods: {
        // dateFormat
        dateFormat(format) {
            var date = new Date()
            var format_arr = {
                Y: date.getFullYear(),
                m:
                    date.getMonth() + 1 >= 10
                        ? date.getMonth() + 1
                        : '0' + (date.getMonth() + 1),
                d: date.getDate() >= 10 ? date.getDate() : '0' + date.getDate(),
                H:
                    date.getHours() >= 10
                        ? date.getHours()
                        : '0' + date.getHours(),
                i:
                    date.getMinutes() >= 10
                        ? date.getMinutes()
                        : '0' + date.getMinutes(),
                s:
                    date.getSeconds() >= 10
                        ? date.getSeconds()
                        : '0' + getSeconds(),
            }
            for (var key in format_arr) {
                format = format.replace(key, format_arr[key])
            }
            return format
        },
        // 
        adminMyDataHandleCurrentChange(val) {
            this.adminMyDataCurrentPage = val
        },
        onLoadCheckingDataDict() {
            let CQL_FILTER = `coor_x>0 and coor_y >0 and location_1=0 and check_stat=0`
            let url_params = {
                service: 'WFS',
                version: '1.0.0',
                request: 'GetFeature',
                typeName: 'lwdgis:v3data',
                outputFormat: 'application/json',
                sortBy: 'id',
                CQL_FILTER: CQL_FILTER,
            }
            let vtSource = new VectorSource({
                format: new GeoJSONFormat({
                    // geometryName: 'geom' // 因为数据源里面字段the_geom存储的是geometry，所以需要指定
                }),
            })
            let self = this
            axios({
                url: $webConfig.V3.owsBaseURL,
                method: 'get',
                params: url_params,
            }).then((res) => {
                var featureList = vtSource.getFormat().readFeatures(res.data)
                featureList.forEach((item, index) => {
                    item.setGeometry(
                        item.getGeometry().transform('EPSG:4326', 'EPSG:3857')
                    )
                    vtSource.addFeature(item)
                })
                let tempLayer = new VectorLayer({
                    source: vtSource,
                    // style: pointStyle,
                    title: '当前页待审核图层',
                    zIndex: 999,
                })

                tempLayer
                    .getSource()
                    .getFeatures()
                    .forEach((feature) => {
                        let property = feature.getProperties()
                        if (!(property.user in this.checkingDataDict)) {
                            this.checkingDataDict[property.user] = [property]
                        } else {
                            this.checkingDataDict[property.user].push(property)
                        }

                    })
            })
        },
        onLoadCheckedDataDict() {
            axios({
                url: $webConfig.V3.backendAPI + 'getAccountCheckAll',
                method: 'post',
                data: JSON.stringify({
                }),
            }).then((res) => {
                this.checkedDataDict = res.data.data.resList
            })
        },
        formatchecked2(array) {
            if (array != undefined) {
                if ((array.length) == 0) {
                    return '无'
                } else {
                    let res = ""
                    array.forEach(item => {
                        let temp = item.juluo + "  "
                        res += temp

                    })
                    return res
                }
            } else {
                return '无'
            }

        },
        formatchecked3(array) {
            if (array != undefined) {
                if ((array.length) == 0) {
                    return '无'
                } else {
                    let res = ""
                    array.forEach(item => {
                        let temp = item.name + "  "
                        res += temp

                    })
                    return res
                }
            } else {
                return '无'
            }

        },
        formatchecked1(array) {
            if (array != undefined) {
                if ((array.length) == 0) {
                    return '无'
                } else {
                    let res = String((array.length))
                    // array.forEach(item=>{
                    //     let temp = item.name + "  "
                    //     res += temp

                    // })
                    return res
                }
            } else {
                return '无'
            }

        },
        formatchecked(array) {
            if (array != undefined) {
                if ((array.length) == 0) {
                    return '无'
                } else {
                    let res = String((array.length))
                    // array.forEach(item=>{
                    //     let temp = item.juluo + "  "
                    //     res += temp
                    // })
                    return res
                }
            } else {
                return '无'
            }

        },
        // 注册用户模块 查看详情
        adminDataViewDetil(value) {
            this.accountUserDialogObject = value
            this.accountUserDialogFlag = true
        },
        //判断是否是管理员用户
        isAdminAccount() {
            axios({
                url: $webConfig.V3.backendAPI + 'isAdminAccount',
                method: 'post',
                data: JSON.stringify({
                    mail: this.getUser(),
                }),
            }).then((res) => {
                if (res.data.role == '管理员') {
                    this.adminAccountFlag = true
                    // 去拿管理员能看到的用户信息
                    this.onloadAdminMydata()
                } else if (res.data.role == '普通用户') {
                    this.adminAccountFlag = false
                }

            })
        },
        // 管理员看注册用户
        onloadAdminMydata() {
            axios({
                url: $webConfig.V3.backendAPI + 'getAllUsers',
                method: 'post',
                data: JSON.stringify({
                }),
            }).then((res) => {
                res.data.data.resList.forEach(item => {
                    this.adminMyData.push(Object.assign(item, { checked: this.checkedDataDict[item.mail] }, { checking: this.checkingDataDict[item.mail] }))
                })
                // console.log(this.adminMyData)
            })
        },
        // V3版本
        getUserName: function () {
            if (this.$cookie.get('mail') == null) {
                return this.$store.state.V3mail
            } else {
                return this.$cookie.get('mail')
            }
        },
        // 获取当前用户的信息
        getAccountInfo() {
            let mail = this.getUserName()
            axios({
                url: $webConfig.V3.backendAPI + 'getAccountInfo',
                method: 'post',
                data: JSON.stringify({
                    mail: mail,
                }),
            }).then((res) => {
                this.accountInfo = res.data.data
                // 赋值用户等级
                this.userLV = this.getLV(parseInt(res.data.data.points))

                this.$store.state.userPt = parseInt(res.data.data.points)
                this.$store.state.userLv = this.getLV(
                    parseInt(res.data.data.points)
                )
            })
        },
        // 获取积分记录
        getUserOpertions() {
            let mail = this.getUserName()

            axios({
                url: $webConfig.V3.backendAPI + 'getPointsRecords',
                method: 'post',
                data: JSON.stringify({
                    mail: mail,
                }),
            }).then((res) => {
                // console.log(res.data.data.resList)
                this.point_table = res.data.data.resList
            })
        },
        // 21021-12-09 去拿当前用户定位管理员还没有来得及审核的数据
        refresh(CQL_FILTER) {
            let url_params = {
                service: 'WFS',
                version: '1.0.0',
                request: 'GetFeature',
                typeName: 'lwdgis:v3data',
                outputFormat: 'application/json',
                sortBy: 'id',
                CQL_FILTER: CQL_FILTER,
            }
            let vtSource = new VectorSource({
                format: new GeoJSONFormat({
                    // geometryName: 'geom' // 因为数据源里面字段the_geom存储的是geometry，所以需要指定
                }),
            })
            let self = this
            axios({
                url: $webConfig.V3.owsBaseURL,
                method: 'get',
                params: url_params,
            }).then((res) => {
                var featureList = vtSource.getFormat().readFeatures(res.data)


                featureList.forEach((item, index) => {
                    // 只对审核中的数据做处理
                    if (item.getProperties().check_stat == '0') {
                        item.setGeometry(
                            item.getGeometry().transform('EPSG:4326', 'EPSG:3857')
                        )
                        vtSource.addFeature(item)
                    }

                })


                self.currentPageCheckLayer = new VectorLayer({
                    source: vtSource,
                    // style: pointStyle,
                    title: '当前页待审核图层',
                    zIndex: 999,
                })

                // 给myData赋值
                self.currentPageCheckLayer
                    .getSource()
                    .getFeatures()
                    .forEach((feature) => {
                        let property = feature.getProperties()
                        // console.log(property)
                        let temp = {
                            checkDate: '尚未审核',
                            country: property['lev2_name'],
                            dataID: property['id'] + '',
                            date: property['input_time'],
                            juluo: property['name'],
                            location:
                                property['coor_x'] + ',' + property['coor_y'],
                            mail: property['user'],
                            nPosition: property['n_position'],
                            other: property['input_reas'],
                            tName: property['other'],
                            work: property['input_work'],
                        }
                        self.myData.unshift(temp)
                    })
            })
        },
        // 获取指定用户的定位信息封装
        packGetData() {

        },
        // 获取myData()
        getMyData() {
            let mail = this.getUserName()

            axios({
                url: $webConfig.V3.backendAPI + 'getAccountCheck',
                method: 'post',
                data: JSON.stringify({
                    mail: mail,
                }),
            }).then((res) => {
                this.myData = []
                this.myData = res.data.data.resList
                // 获取我定位的数据但是管理员没有来得及审核的数据
                if (this.isAdminAccount) {
                    this.refresh()
                } else {
                    this.refresh(
                        ' user=' +
                        "'" +
                        this.getUserName() +
                        "'  "
                    )
                }

                // this.refresh(
                //     'coor_x>0 and coor_y >0 and location_1=0 and check_stat=0 ' 
                // )
            })
        },
        // 获取人物信息
        getUserPoints() {
            axios({
                url: $webConfig.baseAPI + 'getPoints/',
                method: 'get',
                params: {
                    name: this.$store.state.userName,
                },
            }).then((res) => {
                let data = res.data.data
                this.$store.state.userEmail = data.mail
            })
        },
        // 跳转到首页 查看地图 地图上展示聚落弹框
        jumpViewJuLuo(value) {
            // 聚落id 为整形
            value['id'] = parseInt(value['dataID'])
            this.$router.push({ name: 'home' })
            setTimeout(() => {
                eventBus.emit(
                    'jumpViewJuLuo',
                    JSON.parse(JSON.stringify(value))
                )
            }, 1000)
        },
        // 增加 管理员可以对 已审核通过的 聚落进行删除，回到未定位状态
        //自己定位了 但是管理员没有审核 现在要自己删除
        deletechecking(value) {
            this.currentPageCheckLayer
                .getSource()
                .getFeatures()
                .forEach((feature) => {
                    let property = feature.getProperties()
                    // console.log(property)
                    if (property.id + '' == value.dataID) {
                        let value = {
                            check_reas: '自己定位的，自己先删除了',
                            check_stat: 2,
                            data: property,
                        }
                        this.passFailed(value)
                    }
                })
        },

        // 审核不通过 改变数据
        // 数据点改变 如果是从来没有定位的点回到未通过 如果是是之前通过的点用户更改坐标审核的回到更改之前的状态
        // 历史记录记录
        passFailed(value) {
            let self = this
            // 判断是哪一种
            // 如果是从来没有定位的点回到未通过 如果是是之前通过的点用户更改坐标审核的回到更改之前的状态
            let dataID = value.data.id + ''

            axios({
                url: $webConfig.V3.backendAPI + 'getPassDatas',
                method: 'post',
                data: JSON.stringify({
                    dataID: dataID,
                }),
            }).then((res) => {

                if (res.data.data.count == 0) {
                    // 如果是从来没有定位的点回到未通过

                    let features = []
                    this.currentPageCheckLayer
                        .getSource()
                        .getFeatures()
                        .forEach((feature) => {
                            if (feature.getProperties().id == value.data.id) {
                                // 注意 要改变 数据点原始属性值 由于投影的原有 经纬度也要跟着改变
                                let centerLonLat = [
                                    feature.getGeometry().getExtent()[0],
                                    feature.getGeometry().getExtent()[1],
                                ]

                                let transformLonLat = transform(
                                    centerLonLat,
                                    'EPSG:3857',
                                    'EPSG:4326'
                                )
                                let newLonlat = [
                                    transformLonLat[1],
                                    transformLonLat[0],
                                ]
                                feature.getGeometry().setCoordinates(newLonlat)

                                feature.set('check_stat', value.check_stat)
                                feature.set('check_reas', value.check_reas)
                                // 审核日期
                                feature.set(
                                    'remark',
                                    this.dateFormat('Y-m-d H:i:s')
                                )
                                feature.set('location_1', 0)
                                features.push(feature)
                            }
                        })
                    // self.passSuccessXML(features)
                    self.passFailedXML(features, value)
                } else {
                    // 如果是是之前通过的点用户更改坐标审核的回到更改之前的状态

                    let originData =
                        res.data.data.resList[res.data.data.count - 1]
                    let features = []
                    this.currentPageCheckLayer
                        .getSource()
                        .getFeatures()
                        .forEach((feature) => {
                            if (feature.getProperties().id == value.data.id) {
                                // 注意 要改变 数据点原始属性值 由于投影的原有 经纬度也要跟着改变

                                let lonlat = originData.location.split(',')

                                feature
                                    .getGeometry()
                                    .setCoordinates([
                                        parseFloat(lonlat[0]),
                                        parseFloat(lonlat[1]),
                                    ])
                                feature.set('coor_x', parseFloat(lonlat[0]))
                                feature.set('coor_y', parseFloat(lonlat[1]))
                                feature.set('n_position', originData.n_position)
                                feature.set('user', originData.mail)
                                feature.set('input_time', originData.date)
                                feature.set('other', originData.tName)

                                feature.set('input_work', originData.work)
                                feature.set('input_reas', originData.other)
                                // 审核日期
                                feature.set('remark', originData.checkDate)

                                feature.set('check_stat', 1)
                                feature.set('location_1', 1)
                                features.push(feature)
                            }
                        })
                    self.passFailedXML(features, value)
                }
            })
        },
        // 审核不通过 改变数据发送请求体
        passFailedXML(features, value) {
            let self = this
            let WFSTSerializer = new WFS()
            let featObject = WFSTSerializer.writeTransaction(
                null,
                features,
                null,
                {
                    featureType: 'v3data', //feature对应图层
                    featureNS: $webConfig.V3.GeoseverIP + '/lwdgis', //为创建工作区时的命名空间URI
                    geometryName: 'geom',
                }
            )
            // 转换为xml内容发送到服务器端
            let serializer = new XMLSerializer()
            let featString = serializer.serializeToString(featObject)

            const axioInstance = axios.create()
            // 请求拦截器
            axioInstance.interceptors.request.use(
                (config) => {
                    fullScreenStartLoading()
                    return config
                },
                (error) => {
                    Promise.reject(error)
                }
            )
            // 响应拦截器
            axioInstance.interceptors.response.use(
                (response) => {
                    fullScreenEndLoading()
                    return response
                },
                (error) => {
                    fullScreenEndLoading()
                    return Promise.reject(error)
                }
            )
            // 发送请求
            axioInstance
                .post(
                    $webConfig.V3.GeoseverIP + '/wfs?service=wfs',
                    this.replaceText(featString, 'geom', 'v3data'),
                    {
                        headers: {
                            'Content-Type': 'text/xml',
                        },
                    }
                )
                .then((e) => {
                    self.failedRecordOperation(
                        '数据点定位审核',
                        '自己定位的，自己先删除了',
                        features[0].getProperties()
                    )
                    if (e.status == 200) {
                        // console.log(e)
                        self.$message({
                            message: '删除完成,该聚落回到原来数据列表中。',
                            type: 'success',
                        })
                        self.getMyData()
                        // // 发送审核不成功邮件
                        // axios({
                        //     url: $webConfig.V3.backendAPI + 'sendMail',
                        //     method: 'post',
                        //     data: JSON.stringify({
                        //         name: value.data.name,
                        //         lev2_name: value.data.lev2_name,
                        //         input_reas: value.data.input_reas,
                        //         input_time: value.data.input_time,
                        //         check_reas: value.check_reas,
                        //         user: value.data.user,
                        //     }),
                        // })
                        // // 重新加载左侧表格组件 右侧地图组件
                        // // self.reloadTimer = new Date().getTime()
                        // self.$emit('reloadComponents')
                    }
                })
        },
        failedRecordOperation(content, result, property) {
            // // 记录用户行为 修改数据
            // 注意日期
            let operationJSON = {
                mail: this.getUser(),
                tName: this.tName,
                dataID: property.id,
                juluo: property.name,
                country: property.lev2_name,
                date: this.dateFormat('Y-m-d H:i:s'),
                content: content,
                result: result,
                other: '',
            }
            axios.post($webConfig.V3.backendAPI + 'addOperation', operationJSON)
        },
        // 不知道为什么 更改点位置 的xml 请求体有问题 替换其中的关键字即可
        // 找了好久
        replaceText(text, key1, key2) {
            let temp1 = 'feature:' + key2
            let temp2 = 'lwdgis:' + key2
            return text.replace('geometry', key1).replace(temp1, temp2)
        },
        // getUser() // 当前系统用户名
        getUser() {
            if (this.$cookie.get('mail') == null) {
                return this.$store.state.V3mail
            } else {
                return this.$cookie.get('mail')
            }
        },
        //gettName() // 当前系统用户名真实姓名
        gettName() {
            axios({
                url: $webConfig.V3.backendAPI + 'getUsertName',
                method: 'post',
                data: JSON.stringify({
                    mail: this.getUser(),
                }),
            }).then((res) => {
                if (res.data.tName) {
                    this.tName = res.data.tName
                } else {
                    this.tName = ''
                }
            })
        },
        getLV(points) {
            if (points < 60) {
                return 'LV2'
            } else if (points < 180) {
                return 'LV3'
            } else if (points < 360) {
                return 'LV4'
            } else if (points < 600) {
                return 'LV5'
            } else if (points < 1800) {
                return 'LV6'
            } else if (points < 3200) {
                return 'LV7'
            } else {
                return 'LV0'
            }
        },

        /**
         * @Date: 2021-03-19 11:20:58
         * @autor: Zyr
         * 获取人物信息
         */
        getUserInfo() {
            axios({
                url: $webConfig.YAPI + 'user/info',
                method: 'get',
                params: {
                    username: this.$store.state.userName,
                },
            })
                .then((res) => {
                    this.$store.state.userEmail = res.data.email
                    this.$store.state.userUnit = res.data.unit
                    this.$store.state.userWork = res.data.work
                    this.$store.state.userLv = res.data.lv
                    this.$store.state.userPt = res.data.point
                })
                .catch((err) => { })
        },
        /**
         * @Date: 2021-03-19 11:21:25
         * @autor: Zyr
         * 获取历史操作
         */
        getHistoryAction() {
            axios({
                url: $webConfig.YAPI + 'user/history',
                method: 'get',
                params: {
                    username: this.$store.state.userName,
                },
            })
                .then((res) => {
                    this.point_table = res.data.data
                })
                .catch((err) => { })
        },
        /**
         * @Date: 2021-02-22 21:10:05
         * @autor: Zyr
         * 修改密码
         */
        goto_change_password() {
            this.code_dialogVisible = true
        },
        /**
         * @Date: 2021-02-23 19:58:32
         * @autor: Zyr
         * 显示积分规则
         */
        goto_point_rule() {
            this.point_dialogVisible = true
            this.$nextTick(() => {
                this.drawChart()
            })
        },
        /**
         * @Date: 2021-02-22 21:10:15
         * @autor: Zyr
         * <!--发送验证码-->
         */

        sendCode() {
            let email = this.ruleForm2.email
            if (this.checkMobile(email)) {
                //           （1）将用户id写入cookies中
                //         this.$cookies.set("userId","9527")
                // （2）获取写入的id的cookies
                //        let userId= this.$cookies.get("userId")
                //        则，userId=9527;
                //  (3) 删除写入的id的cookies
                //        this.$cookies.remove("userId")
                // console.log(axios.defaults.withCredentials)
                axios({
                    url: $webConfig.baseAPI + 'mail/',
                    method: 'post',
                    data: JSON.stringify({ mail: email }),
                })
                    .then((res) => {
                        console.log(res)
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                let time = 60
                this.buttonText = '已发送'
                this.isDisabled = true
                if (this.flag) {
                    this.flag = false
                    let timer = setInterval(() => {
                        time--
                        this.buttonText = time + ' 秒'
                        if (time === 0) {
                            clearInterval(timer)
                            this.buttonText = '重新获取'
                            this.isDisabled = false
                            this.flag = true
                        }
                    }, 1000)
                }
            }
        },
        // 验证邮箱号
        checkMobile(str) {
            //   let re = /^1\d{10}$/ //验证手机号
            let re = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
            if (re.test(str)) {
                return true
            } else {
                return false
            }
        },
        /**
         * @Date: 2021-03-19 19:32:51
         * @autor: Zyr
         * 清空表格内容
         */
        clearForm() {
            this.ruleForm2.pass = ''
            this.ruleForm2.checkPass = ''
            this.ruleForm2.email = ''
            this.ruleForm2.smscode = ''
        },
        submitForm() {
            if (!this.ruleForm2.email) {
                this.$message.error('请输入信息！')
                return
            } else {
                var reg = /^(?:\w+\.?)*\w+@(?:\w+\.)*\w+$/
                if (!reg.test(this.ruleForm2.email)) {
                    this.$message.error('邮箱格式不正确，请重新输入！')
                    return false
                } else {
                    axios({
                        url: $webConfig.baseAPI + 'forget/',
                        method: 'post',
                        data: JSON.stringify({
                            uname: this.$store.state.userName,
                            mail: this.ruleForm2.email,
                        }),
                    })
                        .then((res) => {
                            // console.log(res.data['message']);
                            // console.log("111输出response.data", res.data);
                            // console.log("111输出response.data.status", res.data.status);
                            // console.log(res)
                            if (
                                res.status == 200 &&
                                res.data['message'] == '邮件已发出请查收'
                            ) {
                                this.$message({
                                    message: res.data['message'],
                                    type: 'success',
                                })
                                this.clearForm()
                                this.code_dialogVisible = false
                            } else {
                                this.$message({
                                    message: res.data['message'],
                                    type: 'warning',
                                })
                                // alert("您输入的用户名已存在！");
                            }
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                }
            }
        },

        /**
         * @Date: 2021-02-23 20:02:57
         * @autor: Zyr
         */
        drawChart() {
            let option = {
                tooltip: {
                    show: false,
                },

                xAxis: [
                    {
                        type: 'category',
                        data: $webConfig.level_name,

                        axisTick: {
                            show: false, //不显示坐标轴刻度线
                        },
                        axisLine: {
                            show: false, //不显示坐标轴线
                        },
                    },
                ],
                yAxis: {
                    show: false,
                },
                series: [
                    {
                        name: '积分',
                        type: 'bar',
                        data: $webConfig.level_num,
                        hoverAnimation: false,
                        barWidth: 30,
                        color: '#12C287',
                        itemStyle: {
                            //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
                            emphasis: {
                                barBorderRadius: 30,
                            },

                            normal: {
                                //柱形图圆角，初始化效果

                                label: {
                                    show: true, //是否展示
                                    position: 'top',
                                    textStyle: {
                                        fontSize: '12',
                                        fontFamily: '微软雅黑',
                                    },
                                },
                            },
                        },
                    },
                ],
            }
            let myChart = {}
            myChart = this.$echarts.init(document.getElementById('divChart'))
            myChart.setOption(option)
            window.addEventListener('resize', () => {
                myChart.resize()
            })
        },
        // 属性表格 翻页
        //每页条数改变时触发 选择一页显示多少行
        recordHandleSizeChange(val) {
            this.recordCurrentPage = 1
            this.recordPageSize = val
        },
        //当前页改变时触发 跳转其他页
        recordHandleCurrentChange(val) {
            this.recordCurrentPage = val
        },
        myDataHandleCurrentChange(val) {
            this.myDataCurrentPage = val
        },
    },
}
</script>


<style scoped>
.change-code-form-center {
    height: 100%;
    position: relative;
    top: 3%;
    left: 30%;
    margin-left: 1rem;
}

.change-code-form-right {
    height: 100%;

    margin-left: 1rem;
}

.code>>>.el-form-item__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.border-box>>>.el-table {
    font-size: 20px;
}

.border-box>>>.el-table td,
.el-table th {
    padding: 12px 0px;
}

/* .border-box >>> .el-table tr{
    height: 50px !important;
} */

.aDdiv {
    text-align: left;
}

.aDdiv .aDhead {
    font-size: 20px;
    font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/V3/MyAccount.vue